import { useSelector } from 'react-redux';

export const useGameFen = () => {
    return useSelector((state) => state.game?.gameFen);
};

export const useIsWhite = () => {
    return useSelector((state) => state.game?.isWhite);
};

export const useIsMyTurn = () => {
    return useSelector((state) => (state.game?.moveHistory.length % 2 === 0) === state.game.isWhite);
};

export const useMoveHistory = () => {
    return useSelector((state) => state.game?.moveHistory);
};

export const usePlayer = () => {
    return useSelector((state) => state.game?.player);
};

export const useOpponent = () => {
    return useSelector((state) => state.game?.opponent);
};

export const useMyBombs = () => {
    return useSelector((state) => state.game?.player.bombs);
};

export const useMyTimeLeft = () => {
    return useSelector((state) => state.game?.player.secondsLeft);
}

export const useOpponentTimeLeft = () => {
    return useSelector((state) => state.game?.opponent.secondsLeft);
}

export const useBombPlantingTime = () => {
    return useSelector((state) => state.game?.placingBombsSeconds);
}

export const useBombTimerSyncedAt = () => {
    return useSelector((state) => state.game?.bombTimerSyncedAt);
}

export const useGameState = () => {
    return useSelector((state) => state.game?.gameState);
}